import { render, staticRenderFns } from "./RapAlgemeen.vue?vue&type=template&id=c579c82e&scoped=true"
import script from "./RapAlgemeen.vue?vue&type=script&lang=js"
export * from "./RapAlgemeen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c579c82e",
  null
  
)

export default component.exports